class WPTCourseFinder extends HTMLElement {
  constructor() {
    super();
    // Variables
    this.slides = Array.from(this.querySelectorAll(".slide"));
    this.nextSlideButtons = this.querySelectorAll("button[data-next]");
    this.restartButtons = this.querySelectorAll("button[data-restart]");
    this.radioButtons = this.querySelectorAll("input[type='radio']");
    this.activeIndex = 0;

    // Functions
    this.nextSlideButtons.forEach((button) => {
      button.addEventListener("click", this.nextSlide.bind(this));
    });
    this.restartButtons.forEach((button) => {
      button.addEventListener("click", this.restartSlides.bind(this));
    });
    this.radioButtons.forEach((radio) => {
      radio.addEventListener("change", this.enableNextButton.bind(this));
    });

    this.updateSlides();
  }

  updateSlides() {
    this.slides.forEach((slide, idx) => {
      slide.classList.toggle("is-active", idx === this.activeIndex);
    });
    this.nextSlideButton =
      this.slides[this.activeIndex].querySelector("button[data-next]");
    if (this.nextSlideButton) {
      this.nextSlideButton.setAttribute("disabled", "true");
    }
  }

  enableNextButton(event) {
    event.preventDefault();
    this.nextSlideButton =
      this.slides[this.activeIndex].querySelector("button[data-next]");
    if (this.nextSlideButton) {
      this.nextSlideButton.removeAttribute("disabled");
    }
  }

  restartSlides(event) {
    event.preventDefault();
    this.activeIndex = 0;
    this.radioButtons.forEach((radio) => {
      radio.checked = false;
    });
    this.updateSlides();
  }

  nextSlide(event) {
    event.preventDefault();
    const activeSlide = this.slides[this.activeIndex];
    const selectedRadio = activeSlide.querySelector(
      "input[type='radio']:checked"
    );
    if (selectedRadio) {
      const targetIndex = this.slides.findIndex(
        (slide) => slide.getAttribute("data-slide-id") === selectedRadio.value
      );
      if (targetIndex !== -1) {
        // Hide current slide
        activeSlide.classList.add("hidden");
        // Show next slide
        this.slides[targetIndex].classList.remove("hidden");

        this.activeIndex = targetIndex;
        this.updateSlides();
        const nextSlide = this.slides[targetIndex];
        const firstTabbable = nextSlide.querySelector("h3");
        if (firstTabbable) {
          firstTabbable.focus();
        }
      }
    }
  }
}

customElements.define("wpt-course-finder", WPTCourseFinder);
